/**
 * Floating coffee-bean backdrop for the header drawer
 * (snippets/header-drawer.liquid, canvas.tng-drawer-beans). Purely
 * decorative -- the frosted-glass panels in the drawer (quick-nav,
 * featured-product captions, quick-contact) exist to blur this moving
 * layer, not a flat colour.
 *
 * Drawn on a <canvas> via requestAnimationFrame rather than a CSS
 * `animation`, on purpose: HeaderDrawer#close() waits for every CSS
 * Animation on the drawer element to finish before it can clean up
 * (see assets/utilities.js onAnimationEnd) -- a canvas loop has no CSS
 * Animation object, so it can't reproduce the drawer close-hang fixed in
 * 532de31 (that bug came from an `animation: ... infinite` placed
 * directly on .menu-drawer).
 *
 * Only runs while the drawer is open (paused via IntersectionObserver
 * would be overkill for a fixed-position panel -- toggled from the
 * `open`/`toggle` events HeaderDrawer's <details> already dispatches).
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function init(canvas) {
    var ctx = canvas.getContext('2d');
    var reduced = prefersReducedMotion();
    var beans = [];
    var raf = null;
    var running = false;

    function resize() {
      var r = canvas.getBoundingClientRect();
      if (r.width === 0 || r.height === 0) return;
      canvas.width = r.width * devicePixelRatio;
      canvas.height = r.height * devicePixelRatio;
      ctx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
    }

    function makeBeans() {
      var r = canvas.getBoundingClientRect();
      var count = Math.max(10, Math.round((r.width * r.height) / 9000));
      beans = [];
      for (var i = 0; i < count; i++) {
        beans.push({
          x: Math.random() * r.width,
          y: Math.random() * r.height,
          s: 9 + Math.random() * 13,
          rot: Math.random() * Math.PI * 2,
          spin: (Math.random() - 0.5) * 0.0016,
          vy: 0.05 + Math.random() * 0.09,
          drift: Math.random() * Math.PI * 2
        });
      }
    }

    function drawBean(b) {
      ctx.save();
      ctx.translate(b.x, b.y);
      ctx.rotate(b.rot);
      ctx.beginPath();
      ctx.ellipse(0, 0, b.s * 0.55, b.s, Math.PI / 5, 0, Math.PI * 2);
      ctx.fillStyle = '#e9c893';
      ctx.globalAlpha = 0.35;
      ctx.fill();
      ctx.strokeStyle = '#3a1d10';
      ctx.globalAlpha = 0.45;
      ctx.lineWidth = 1.1;
      ctx.beginPath();
      ctx.moveTo(0, -b.s * 0.85);
      ctx.quadraticCurveTo(b.s * 0.18, 0, 0, b.s * 0.85);
      ctx.stroke();
      ctx.restore();
    }

    function frame() {
      if (!running) return;
      var r = canvas.getBoundingClientRect();
      ctx.clearRect(0, 0, r.width, r.height);
      var grad = ctx.createLinearGradient(0, 0, r.width, r.height);
      grad.addColorStop(0, '#3a1d10');
      grad.addColorStop(1, '#241109');
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, r.width, r.height);
      beans.forEach(function (b) {
        if (!reduced) {
          b.y -= b.vy;
          b.drift += 0.0035;
          b.x += Math.sin(b.drift) * 0.12;
          b.rot += b.spin;
          if (b.y < -20) {
            b.y = r.height + 20;
            b.x = Math.random() * r.width;
          }
        }
        drawBean(b);
      });
      if (reduced) return; // static frame is enough; no need to keep looping
      raf = requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      running = true;
      resize();
      if (!beans.length) makeBeans();
      frame();
    }

    function stop() {
      running = false;
      if (raf) cancelAnimationFrame(raf);
      raf = null;
    }

    window.addEventListener('resize', function () {
      if (!running) return;
      resize();
      makeBeans();
    });

    var details = canvas.closest('details');
    if (details) {
      if (details.hasAttribute('open')) start();
      details.addEventListener('toggle', function () {
        if (details.hasAttribute('open')) start();
        else stop();
      });
    } else {
      start();
    }
  }

  var canvas = document.querySelector('.tng-drawer-beans');
  if (canvas) init(canvas);
})();
